export function splitTextLines(text) {
  return text.split('\n')
}

/**
 * @param {string} text
 * @param {'preserve' | 'sentence'} lineBreak
 */
export function expandTextToLines(text, lineBreak = 'preserve') {
  const raw = String(text ?? '')
  if (lineBreak === 'preserve') {
    return splitTextLines(raw)
  }

  const lines = []
  for (const segment of raw.split('\n')) {
    if (!segment.trim()) {
      lines.push('')
      continue
    }
    const sentences = segment.match(/[^.!?]+[.!?]+(?:\s+|$)|[^.!?]+$/g) ?? [segment]
    for (const sentence of sentences) {
      const trimmed = sentence.trim()
      if (trimmed) lines.push(trimmed)
    }
  }
  return lines.length ? lines : ['']
}

export function joinLines(lines, count) {
  return lines.slice(0, count).join('\n')
}

export function planLineRevealInterval(lineCount, durationMs, minIntervalMs = 1) {
  const perLine = Math.floor(durationMs / Math.max(1, lineCount))
  return Math.max(minIntervalMs, perLine)
}

export function planCharRevealSteps(textLength, durationMs, minIntervalMs = 1) {
  const steps = Math.max(1, Math.min(textLength, Math.floor(durationMs / Math.max(minIntervalMs, 16))))
  return {
    intervalMs: Math.max(minIntervalMs, Math.floor(durationMs / steps)),
    charsPerStep: Math.ceil(textLength / steps),
  }
}
